module.exports = __webpack_public_path__ + "1642699981952/static/media/authBastaoVermelho.e9cd5c6d.svg";